
export const environment = {
   production: false,
   apiUrl: "https://63wsqwbd0a.execute-api.us-east-1.amazonaws.com/stage/contactPeople",
   apiKey: "MMYzHfJ44o2T7bRAanhE47DTSk4yLxRs3sZOoQJS",
   COGNITO_TOKEN_URL: "https://63wsqwbd0a.execute-api.us-east-1.amazonaws.com/stage/getAuthToken",
   ipifyUrl: "https://api.ipify.org?format=json"
};
